/**
 * Gets the contentId of the specified draft content's parent by looking in the GraphQL cache.
 * If it's unable to find the parent, returns undefined.
 */
export const getParentOfDraft = async (
	contentId: string,
	readFragmentInterop: any,
): Promise<string | undefined> => {
	// Apollo's `readQuery` method will throw an error if ANY of the requested fields are missing.
	// We want to gracefully handle this and return `undefined`, so we use the try/catch block to swallow errors.
	let parentId: string | undefined = undefined;
	try {
		const draftData = readFragmentInterop({
			id: `Content:${contentId}`,
		});
		parentId = draftData?.ancestors?.slice(-1)?.[0]?.id;
	} catch {}

	return parentId;
};
